import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components';

const PopoverContainer = styled.div`
    position: relative;
    display: inline-block;
    
    & > {
        span {
            font-family: "SatoshiRegular";
            font-size: 12px;
            font-weight: 400;
            cursor: pointer;
            margin-left: 5px;
        }
    }
`

const PopoverContent = styled.div`
    position: absolute;
    left: 0;
    padding: 10px;
    border-radius: 10px;
    background-color: ${(props) => props.theme.black};
    border: 1px solid ${(props) => props.theme.borderColor};
    box-shadow: 3px 2px 30px rgba(68, 68, 68, 0.12);
    opacity: 1;
    z-index: 10;
`

export const ChoosenSelectionsPopover = ({ children, content }) => {
    const [isOpen, setIsOpen] = useState(false);
    const popoverRef = useRef(null);

    const togglePopover = () => {
        setIsOpen((prev) => !prev);
    };

    const handleClickOutside = (event) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    return (
        <PopoverContainer ref={popoverRef}>
            <span onClick={togglePopover}>
                {children}
            </span>
            {isOpen && (
                <PopoverContent>
                    {content}
                </PopoverContent>
            )}
        </PopoverContainer>
    )
}
